module.exports = __webpack_public_path__ + "img/fangzhang.97e77b29.png";